/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './inbox.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/forms';
import * as import3 from '@angular/common';
import * as import4 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import5 from '@angular/material';
import * as import6 from 'md2/core/compatibility/compatibility';
import * as import7 from 'ngx-pagination';
import * as import8 from '../../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import9 from '../../shared/ui/mobile-header/mobile-header.component.ngfactory';
import * as import10 from '../../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import11 from '@angular/router';
import * as import12 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import13 from '../../../../app/messaging/inbox/inbox.component';
import * as import14 from '../../../../$$_gendir/node_modules/ngx-perfect-scrollbar/dist/lib/perfect-scrollbar.component.ngfactory';
import * as import15 from 'ngx-perfect-scrollbar/dist/lib/perfect-scrollbar.component';
import * as import16 from '../../../../app/notification/notification.service';
import * as import17 from '../../../../app/api/messaging.service';
import * as import18 from '../../../../app/spinner/spinner.service';
import * as import19 from '../../../../app/shared/sub-organisation-filter/sub-organisation-filter.service';
const styles_InboxComponent:any[] = [import0.styles];
export const RenderType_InboxComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_InboxComponent,
  data: {}
}
);
function View_InboxComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),26,'section',[[
        'id',
        'filters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),23,'section',[[
        'class',
        'search-bar'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-glass'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,'form',[
      [
        'class',
        'common-form compact'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngSubmit'
      ]
      ,
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,9).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,9).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('ngSubmit' === en)) {
        const pd_2:any = ((<any>co.searchInterpreter()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.ɵbf,([] as any[]),(null as any),(null as any)),
      import1.ɵdid(16384,[[
        'filterBySearch',
        4
      ]
    ],0,import2.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),{ngSubmit: 'ngSubmit'}),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.NgForm]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'input',[
      [
        'id',
        'search'
      ]
      ,
      [
        'name',
        'search'
      ]
      ,
      [
        'placeholder',
        'Search Interpreter By Name'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'click'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,14)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,14).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,14)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,14)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('blur' === en)) {
        const pd_4:any = ((<any>co.searchInterpreter()) !== false);
        ad = (pd_4 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_5:any = ((<any>(co.searchInterpreterQuery = $event)) !== false);
        ad = (pd_5 && ad);
      }
      if (('click' === en)) {
        const pd_6:any = ((<any>(('' !== co.searchInterpreterQuery) && co.clear())) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',[[
        'name',
        'btnSearch'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-glass'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.searchInterpreter()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_14:any = 'search';
    const currVal_15:any = co.searchInterpreterQuery;
    ck(v,16,0,currVal_14,currVal_15);
  },(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,11).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,11).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,11).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,11).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,11).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,11).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,11).ngClassPending;
    ck(v,7,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_7:any = import1.ɵnov(v,18).ngClassUntouched;
    const currVal_8:any = import1.ɵnov(v,18).ngClassTouched;
    const currVal_9:any = import1.ɵnov(v,18).ngClassPristine;
    const currVal_10:any = import1.ɵnov(v,18).ngClassDirty;
    const currVal_11:any = import1.ɵnov(v,18).ngClassValid;
    const currVal_12:any = import1.ɵnov(v,18).ngClassInvalid;
    const currVal_13:any = import1.ɵnov(v,18).ngClassPending;
    ck(v,13,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13);
  });
}
function View_InboxComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵppd(2),
    (l()(),import1.ɵted((null as any),[' |\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'messages__conversation-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import1.ɵunv(v,3,0,ck(v,4,0,import1.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),(<any>v.parent).context.$implicit.last_messaging_time,'h:mma'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (<any>v.parent).context.$implicit.user_name;
    ck(v,7,0,currVal_1);
    const currVal_2:any = (<any>v.parent).context.$implicit.last_message_body.substring(0,75);
    ck(v,10,0,currVal_2);
  });
}
function View_InboxComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵppd(2),
    (l()(),import1.ɵted((null as any),[' |\n                            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'messages__conversation-text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' ..... '])),
    (l()(),import1.ɵted((null as any),['\n                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import1.ɵunv(v,3,0,ck(v,4,0,import1.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),(<any>v.parent).context.$implicit.last_messaging_time,'h:mma'));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (<any>v.parent).context.$implicit.user_name;
    ck(v,7,0,currVal_1);
  });
}
function View_InboxComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),24,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),21,'section',[[
        'class',
        'messages__conversation'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['messages__conversation_active']),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'md-checkbox',[[
        'class',
        'mat-checkbox'
      ]
    ],[
      [
        2,
        'mat-checkbox-indeterminate',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-checked',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-disabled',
        (null as any)
      ]
      ,
      [
        2,
        'mat-checkbox-label-before',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'change'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('change' === en)) {
        const pd_0:any = ((<any>co.isRead($event,v.context.$implicit.id,v.context.index)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_MdCheckbox_0,import4.RenderType_MdCheckbox)),
    import1.ɵdid(16384,(null as any),0,import5.MdPrefixRejector,[
      [
        2,
        import5.MATERIAL_COMPATIBILITY_MODE
      ]
      ,
      import1.ElementRef
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(4374528,(null as any),0,import5.MdCheckbox,[
      import1.Renderer2,
      import1.ElementRef,
      import1.ChangeDetectorRef,
      import5.FocusOriginMonitor
    ]
    ,{
      disabled: [
        0,
        'disabled'
      ]
      ,
      name: [
        1,
        'name'
      ]
      ,
      checked: [
        2,
        'checked'
      ]

    }
    ,{change: 'change'}),
      import1.ɵdid(16384,(null as any),0,import6.MdPrefixRejector,[[
        2,
        import6.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵprd(5120,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import5.MdCheckbox]),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'a',([] as any[]),[[
        8,
        'name',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showSingleMessageThread(v.context.index)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_4)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_5)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'messages__conversation';
    const currVal_1:any = ck(v,4,0,(v.context.index === co.selectedMessageThread));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_6:any = (v.context.$implicit.unread_messages_count === 0);
    const currVal_7:any = import1.ɵinlineInterpolate(1,'checkRead_',(v.context.index + 1),'');
    const currVal_8:any = (v.context.$implicit.unread_messages_count === 0);
    ck(v,10,0,currVal_6,currVal_7,currVal_8);
    const currVal_10:any = (v.context.$implicit.messages_count > 0);
    ck(v,18,0,currVal_10);
    const currVal_11:any = (v.context.$implicit.messages_count < 1);
    ck(v,21,0,currVal_11);
  },(ck,v) => {
    const currVal_2:any = import1.ɵnov(v,10).indeterminate;
    const currVal_3:any = import1.ɵnov(v,10).checked;
    const currVal_4:any = import1.ɵnov(v,10).disabled;
    const currVal_5:any = (import1.ɵnov(v,10).labelPosition == 'before');
    ck(v,8,0,currVal_2,currVal_3,currVal_4,currVal_5);
    const currVal_9:any = import1.ɵinlineInterpolate(1,'',v.context.$implicit.user_name.replace(' ','-'),'');
    ck(v,15,0,currVal_9);
  });
}
function View_InboxComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'section',[[
        'class',
        'messages__conversations'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['messages__conversations_withPagination']),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'section',[
      [
        'class',
        'messages__conversations-wrapper'
      ]
      ,
      [
        'id',
        'conversations-wrapper'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),3,(null as any),View_InboxComponent_3)),
    import1.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import1.ɵpod([
      'itemsPerPage',
      'currentPage',
      'totalItems'
    ]
    ),
    import1.ɵpid(0,import7.PaginatePipe,[import7.PaginationService]),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'messages__conversations';
    const currVal_1:any = ck(v,2,0,(co.totalItems > 10));
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = import1.ɵunv(v,7,0,import1.ɵnov(v,9).transform(co.messageThreads,ck(v,8,0,10,co.messageThreadPage,co.totalItems)));
    ck(v,7,0,currVal_2);
  },(null as any));
}
function View_InboxComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'button inline-block'
      ]
      ,
      [
        'name',
        'load_previous_messages_btn'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.loadMore()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Load Previous Messages\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_InboxComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'messages__text'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit;
    ck(v,1,0,currVal_0);
  });
}
function View_InboxComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'messages__button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.onTagClicked((<any>v.parent).context.$implicit.tag)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.tag;
    ck(v,1,0,currVal_0);
  });
}
function View_InboxComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),31,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),28,'section',[[
        'class',
        'messages__message'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod([
      'messages__message_left',
      'messages__message_right'
    ]
    ),
    (l()(),import1.ɵted((null as any),['\n\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'figure',[[
        'class',
        'messages__figure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'alt',
        ''
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'section',[[
        'class',
        'messages__inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'messages__title'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'strong',[[
        'class',
        'messages__person'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ' ',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'messages__time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-time'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      ' ',
      ''
    ]
    )),
    import1.ɵppd(2),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_8)),
    import1.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_9)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n                    '])),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'messages__message';
    const currVal_1:any = ck(v,4,0,(v.context.$implicit.sender.type !== 'Interpreter'),(v.context.$implicit.sender.type === 'Interpreter'));
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_6:any = v.context.$implicit.message_body.split('\n');
    ck(v,25,0,currVal_6);
    const currVal_7:any = co.hasTag(v.context.$implicit);
    ck(v,28,0,currVal_7);
  },(ck,v) => {
    const currVal_2:any = import1.ɵinlineInterpolate(1,'',v.context.$implicit.sender.photo_url,'');
    ck(v,8,0,currVal_2);
    const currVal_3:any = v.context.$implicit.sender.first_name;
    const currVal_4:any = v.context.$implicit.sender.last_name.charAt(0);
    ck(v,15,0,currVal_3,currVal_4);
    const currVal_5:any = import1.ɵunv(v,20,0,ck(v,21,0,import1.ɵnov((<any>v.parent),0),v.context.$implicit.created_at,' d MMM  y | h:mma'));
    ck(v,20,0,currVal_5);
  });
}
function View_InboxComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'element element_inline messages__pagination'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[[
        'class',
        'my-pagination ele'
      ]
      ],(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>co.getPage($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import8.View_PaginationControlsComponent_0,import8.RenderType_PaginationControlsComponent)),
    import1.ɵdid(49152,(null as any),0,import7.PaginationControlsComponent,([] as any[]),(null as any),{pageChange: 'pageChange'}),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_InboxComponent_11(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'button messages__formButton'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      '\n        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.message_tag;
    ck(v,1,0,currVal_0);
  });
}
export function View_InboxComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵpid(0,import3.DatePipe,[import1.LOCALE_ID]),
    import1.ɵqud(402653184,1,{componentScroll: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',[
      [
        'backLink',
        '/booking-management'
      ]
      ,
      [
        'title',
        'MESSAGES'
      ]

    ]
    ,(null as any),(null as any),(null as any),import9.View_MobileHeaderComponent_0,import9.RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import10.MobileHeaderComponent,[
      import11.Router,
      import12.BookingHeaderService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      backLink: [
        1,
        'backLink'
      ]
      ,
      showBackLink: [
        2,
        'showBackLink'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),10,'section',[[
        'id',
        'page-messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'main',[[
        'class',
        'hidden-mobile'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['MESSAGES'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),51,'section',[[
        'class',
        'messages'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),16,'section',[
      [
        'class',
        'messages__wrapper'
      ]
      ,
      [
        'id',
        'messages-wrapper'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['messages__wrapper_aside']),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_6)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'perfect-scrollbar',[[
        'id',
        'perfect_scrollbar'
      ]
    ],[
      [
        8,
        'hidden',
        0
      ]
      ,
      [
        2,
        'ps-show-limits',
        (null as any)
      ]
      ,
      [
        2,
        'ps-show-active',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'psYReachStart'
      ]
      ,
      [
        (null as any),
        'psYReachEnd'
      ]
      ,
      [
        'document',
        'touchstart'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import13.InboxComponent = v.component;
      if (('document:touchstart' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,33).onGeneratedEvent($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('psYReachStart' === en)) {
        const pd_1:any = ((<any>co.scrollReachedAtTop()) !== false);
        ad = (pd_1 && ad);
      }
      if (('psYReachEnd' === en)) {
        const pd_2:any = ((<any>co.scrollReachedAtBottom()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },import14.View_PerfectScrollbarComponent_0,import14.RenderType_PerfectScrollbarComponent)),
      import1.ɵdid(507904,[[
        1,
        4
      ]
    ],0,import15.PerfectScrollbarComponent,[
      import1.ElementRef,
      import1.ChangeDetectorRef
    ]
    ,{
      scrollIndicators: [
        0,
        'scrollIndicators'
      ]
      ,
      config: [
        1,
        'config'
      ]

    }
    ,{
      PS_Y_REACH_END: 'psYReachEnd',
      PS_Y_REACH_START: 'psYReachStart'
    }
    ),
    (l()(),import1.ɵted(0,['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),0,1,(null as any),View_InboxComponent_7)),
    import1.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted(0,['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_10)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),24,'form',[
      [
        'class',
        'messages__form'
      ]
      ,
      [
        'novalidate',
        ''
      ]
      ,
      [
        'style',
        'position: fixed;'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,47).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,47).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import3.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import1.ɵpod(['messages__form_reduced']),
    import1.ɵdid(16384,(null as any),0,import2.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(16384,(null as any),0,import2.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.NgForm]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_InboxComponent_11)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),12,'section',[[
        'class',
        'messages__formInner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'textarea',[
      [
        'class',
        'messages__formInput'
      ]
      ,
      [
        'name',
        'message_body'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import13.InboxComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,57)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,57).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,57)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,57)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.message_body = $event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('keyup' === en)) {
        const pd_5:any = ((<any>co.checkEmpty()) !== false);
        ad = (pd_5 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(16384,(null as any),0,import2.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.RequiredValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
    import1.ɵdid(671744,(null as any),0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'button',[
      [
        'class',
        'messages__formSend'
      ]
      ,
      [
        'name',
        'messages__formSend'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import13.InboxComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.sendMessage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import13.InboxComponent = v.component;
    const currVal_0:any = 'MESSAGES';
    const currVal_1:any = '/booking-management';
    const currVal_2:any = true;
    ck(v,3,0,currVal_0,currVal_1,currVal_2);
    const currVal_3:any = co.isCurrentUserAdminOrBookingOfficer();
    ck(v,8,0,currVal_3);
    const currVal_4:any = co.isCurrentUserAdminOrBookingOfficer();
    ck(v,20,0,currVal_4);
    const currVal_5:any = 'messages__wrapper';
    const currVal_6:any = ck(v,24,0,co.isCurrentUserAdminOrBookingOfficer());
    ck(v,23,0,currVal_5,currVal_6);
    const currVal_7:any = ((co.showLoadMore === true) && (co.messageCount > (co.messagePage * 10)));
    ck(v,29,0,currVal_7);
    const currVal_11:any = false;
    const currVal_12:any = co.config;
    ck(v,33,0,currVal_11,currVal_12);
    const currVal_13:any = co.messages;
    ck(v,36,0,currVal_13);
    const currVal_14:any = ((co.totalItems > 10) && co.isCurrentUserAdminOrBookingOfficer());
    ck(v,41,0,currVal_14);
    const currVal_22:any = 'messages__form';
    const currVal_23:any = ck(v,45,0,co.isCurrentUserAdminOrBookingOfficer());
    ck(v,44,0,currVal_22,currVal_23);
    const currVal_24:any = co.isTagShow;
    ck(v,52,0,currVal_24);
    const currVal_33:any = '';
    ck(v,58,0,currVal_33);
    const currVal_34:any = 'message_body';
    const currVal_35:any = co.message_body;
    ck(v,61,0,currVal_34,currVal_35);
  },(ck,v) => {
    var co:import13.InboxComponent = v.component;
    const currVal_8:any = import1.ɵnov(v,33).hidden;
    const currVal_9:any = import1.ɵnov(v,33).autoPropagation;
    const currVal_10:any = import1.ɵnov(v,33).scrollIndicators;
    ck(v,32,0,currVal_8,currVal_9,currVal_10);
    const currVal_15:any = import1.ɵnov(v,49).ngClassUntouched;
    const currVal_16:any = import1.ɵnov(v,49).ngClassTouched;
    const currVal_17:any = import1.ɵnov(v,49).ngClassPristine;
    const currVal_18:any = import1.ɵnov(v,49).ngClassDirty;
    const currVal_19:any = import1.ɵnov(v,49).ngClassValid;
    const currVal_20:any = import1.ɵnov(v,49).ngClassInvalid;
    const currVal_21:any = import1.ɵnov(v,49).ngClassPending;
    ck(v,43,0,currVal_15,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21);
    const currVal_25:any = (import1.ɵnov(v,58).required? '': (null as any));
    const currVal_26:any = import1.ɵnov(v,63).ngClassUntouched;
    const currVal_27:any = import1.ɵnov(v,63).ngClassTouched;
    const currVal_28:any = import1.ɵnov(v,63).ngClassPristine;
    const currVal_29:any = import1.ɵnov(v,63).ngClassDirty;
    const currVal_30:any = import1.ɵnov(v,63).ngClassValid;
    const currVal_31:any = import1.ɵnov(v,63).ngClassInvalid;
    const currVal_32:any = import1.ɵnov(v,63).ngClassPending;
    ck(v,56,0,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32);
    const currVal_36:boolean = !co.message_body;
    ck(v,65,0,currVal_36);
  });
}
function View_InboxComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-inbox',([] as any[]),(null as any),(null as any),(null as any),View_InboxComponent_0,RenderType_InboxComponent)),
    import1.ɵdid(245760,(null as any),0,import13.InboxComponent,[
      import16.NotificationServiceBus,
      import3.PlatformLocation,
      import17.MessagingService,
      import3.Location,
      import18.SpinnerService,
      import11.Router,
      import11.ActivatedRoute,
      import19.SubOrganisationFilterService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const InboxComponentNgFactory:import1.ComponentFactory<import13.InboxComponent> = import1.ɵccf('app-inbox',import13.InboxComponent,View_InboxComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/messaging/inbox/inbox.component.ngfactory.ts